'use strict'

import Axios  from 'axios'
import Config from '../../configuration.js'

/**
 * http://localhost/Specif/EUDO_07676/root/SectionORM/organisme/liste
 */
var charger = function(){
  return new Promise(function(Resolve){
    Axios.get(Config.url.service + '/organisme/liste') // Contacte l'orm pour récupérer les données
    .then(function(Reponse){
      // Traite les organismes
      if (Reponse.statusText == 'OK'){
        Reponse.data.items.sort((a, b) => a.libelle.trim().localeCompare(b.libelle.trim())) // Tri des valeurs par le libellé
        Resolve(Reponse.data.items)
      }
    })
  })
}

export default {
  namespaced: true,

  /**
   * STATE
   */
  state: {
    fiche       : { id: 0 }, // Organisme de la fiche
    items       : [], // Organismes
    villes      : [], // Liste des villes déduites de la liste des organismes
    panelState  : 0,
    filtre      : {
      type  : [],
      ville : [],
      zone  : [],
    },
  },

  /**
   * MUTATIONS
   */
  mutations: {
    /**
     * Actualise l'organisme actuellement consulté
     */
    fiche(State, Fiche){
      State.fiche = Fiche
    },

    /**
     * Actualise la liste des organismes
     */
    items(State, Items){
      State.items = Items
    },

    /**
     * Change l'état du panneau de filtre
     */
    panelState(State, Value){
      State.panelState = Value
    },

    /**
     * Change le filtre type d'organisme
     */
    filtreType(State, Value){
      State.filtre.type = Value
    },

    /**
     * Change le filtre ville
     */
    filtreVille(State, Value){
      State.filtre.ville = Value
    },

    /**
     * Change le filtre zone d'activité
     */
    filtreZone(State, Value){
      State.filtre.zone = Value
    },

    /**
     * Actualise la liste des villes
     */
    villes(State, Items){
      State.villes = Items
    },
  },

  /**
   * GETTERS
   */
  getters: {
    /**
     * Retourne l'organisme chargé
     */
    fiche(State){
      return State.fiche
    },

    /**
     * Retourne la liste des organismes
     */
    items(State){
      return State.items
    },

    /**
     * Retourne l'état du panneau de filtre
     */
    panelState(State){
      return State.panelState
    },

    /**
     * Retourne le filtre type d'organisme
     */
    filtreType(State){
      return State.filtre.type
    },

    /**
     * Retourne le filtre ville
     */
    filtreVille(State){
      return State.filtre.ville
    },

    /**
     * Retourne le filtre zone d'activité
     */
    filtreZone(State){
      return State.filtre.zone
    },

    /**
     * Retourne la liste des villes
     */
    villes(State){
      return State.villes
    },

  },
  /**
   * ACTIONS
   */
  actions: {
    /**
     *
     */
    async liste(Context){
      if (Context.getters['items'].length) return // Organismes déja chargés

      var items = await charger()

      // Parcours les organismes pour :
      // Nettoyer l'orthographe des villes
      // Déterminer une liste de ville
      var hash = []
      for(var i=0;i<items.length;i++){
        if (items[i].ville == null) items[i].ville = ''
        items[i].ville = items[i].ville.trim().toUpperCase()
        if (items[i].ville != '') hash[items[i].ville] = 0
      }

      // Liste des villes
      var villes = Object.keys(hash)
      villes.sort()

      Context.commit('villes', villes)
      Context.commit('items' , items)
    },

    /**
     * Charge une seule fiche
     */
    async fiche(Context, Id){
      await Context.dispatch('liste')
      var items = Context.getters['items']

      // Retrouve l'organisme à partir de son id
      for(var i=0;i<items.length;i++){
        if (items[i].id == Id){
          Context.commit('fiche' , items[i])
          break
        }
      }
    },
  }, // ACTIONS
}
